import { render, staticRenderFns } from "./Cotacoes.vue?vue&type=template&id=5c188cc2&scoped=true&"
import script from "./Cotacoes.vue?vue&type=script&lang=js&"
export * from "./Cotacoes.vue?vue&type=script&lang=js&"
import style0 from "./Cotacoes.vue?vue&type=style&index=0&id=5c188cc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c188cc2",
  null
  
)

export default component.exports